import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { Application } from "./App";
import { FournisseurSession } from "./session";
import "@cabinet/charte";
import "./styles.css";

const client = new QueryClient({
  defaultOptions: {
    queries: {
      // Un plan comptable ne bouge pas pendant une session de saisie : le
      // rafraîchir au moindre retour de focus ferait clignoter la grille sans
      // rien apporter.
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const racine = document.getElementById("racine");
if (!racine) throw new Error("Élément racine introuvable dans index.html.");

createRoot(racine).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <FournisseurSession>
          <Application />
        </FournisseurSession>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
